import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wild-sand flex h-full flex-col justify-between relative p-10 md:p-15" }
const _hoisted_2 = { class: "my-auto py-20 xl:py-30" }
const _hoisted_3 = { class: "o-text-caption truncate font-bold mb-2" }
const _hoisted_4 = { class: "o-text-caption truncate" }
const _hoisted_5 = { class: "o-text-caption truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductImage = _resolveComponent("ProductImage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ProductImage, {
        sku: _ctx.product.sku,
        alt: _ctx.product.title,
        "aspect-ratio": 7/3,
        "width-on-screen": 20,
        "cache-bust": _ctx.product.imageVersion
      }, null, 8, ["sku", "alt", "cache-bust"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.product.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$dictionary.get('b2b/product/quantity')) + " " + _toDisplayString(_ctx.product.quantity), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$dictionary.get('b2b/product/price')) + " " + _toDisplayString(_ctx.product.total.amountWithDecimals), 1)
    ]),
    _createVNode(_component_router_link, {
      to: `/da-dk/produkter/${_ctx.product.sku}`,
      title: _ctx.product.title,
      class: "absolute inset-0 z-1"
    }, null, 8, ["to", "title"])
  ]))
}